
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class MessageDialog extends Vue {
  @Prop({ required: false, default: "Errore" }) private dialogTitle: string;
  @Prop({ required: false, default: "Qualcosa è andato storto!" })
  private dialogText: string;
  @Prop({ required: false, default: "Ok" }) private dialogDismissLabel: string;
  @Prop({ required: false, default: false }) private messageDialogOpen: boolean;

  // --- METHODS
  public closeMessageDialog(): void {
    this.$emit("update:messageDialogOpen", false);
  }
}
